import { cloneDeep } from 'lodash';
import { unMaskPrice } from '@/utils/common';
import {
  getStartOfMonth,
  formatDBDate,
  convertToDateSlash,
  DATE_FORMAT,
} from '@/utils/date';
import { DEAL_SHEET_TARGET_TYPE } from '@/utils/enum';

export const initDealSheetPayload = (
  mainModel,
  listStore = [],
  products = [],
  selectedCategory = [],
) => {
  const params = cloneDeep(mainModel);

  const stores = listStore.map((item) => ({
    id: item.id,
    storeId: item.storeId,
    targetQuantity: unMaskPrice(item.targetQuantity),
  }));

  const details = products.map((item) => ({
    id: item.id,
    productId: item.categoryId ? null : item.productId,
    categoryId: item.productId ? null : item.categoryId,
    targetQuantity: unMaskPrice(item.targetQuantity) || 0,
    targetType: item.targetType,
    discountAmount: unMaskPrice(item.discountAmount) || 0,
    discountType: item.discountType,
    discountPolicyType: item.discountPolicyType,
    productName: item.productName,
    productBrandCode: item?.productBrandCode || '',
    alias: item?.alias || '',
  }));

  return {
    id: params.id,
    name: params.name?.trim() || '',
    code: params.code?.trim() || '',
    targetMin: params.targetMin,
    targetMax: params.targetMax,
    isActive: params.isActive,
    priority: params.priority,
    programType: params.programType,
    targetType: params.targetType,
    startDate: formatDBDate(params.startDate),
    endDate: formatDBDate(params.endDate),
    stores,
    details,
    categories: selectedCategory,
    isLimit: params.isLimit,
    limit: params.limit ? unMaskPrice(params.limit) : 0,
    discountAmount: params.discountAmount
      ? unMaskPrice(params.discountAmount)
      : 0,
    notApplicablePrograms: (params.notApplicablePrograms || [])
      .filter((item) => item && item.code)
      .map((item) => item.code),
    providerId: params.providerId || null,
    subProviderId: params.subProviderId || null,
    includeImeis: Array.isArray(params.includeImeis) ? params.includeImeis : [],
    purchaseOrderIds: (params.purchaseOrders || [])
      .map((po) => (po && po.id) || po)
      .filter(Boolean),
  };
};

export const createInitialFormModel = (defaultPriority) => ({
  id: null,
  code: '',
  name: '',
  startDate: getStartOfMonth(),
  endDate: null,
  products: [],
  notApplicablePrograms: [],
  appliedProducts: [],
  isActive: 1,
  targetMin: '',
  targetMax: '',
  programType: null,
  targetType: DEAL_SHEET_TARGET_TYPE.SALE_OUT,
  stores: [],
  discountAmount: '',
  isLimit: false,
  limit: 0,
  priority: defaultPriority,
  providerId: null,
  subProviderId: null,
  includeImeis: [],
  purchaseOrders: [],
});

export const mapApiResponseToFormModel = (result) => {
  return {
    isActive: result.isActive ? 1 : 0,
    code: result.code || '',
    name: result.name || '',
    targetMin: result.targetMin || '',
    targetMax: result.targetMax || '',
    programType: result.programType,
    targetType: result.targetType,
    priority: result.priority,
    startDate: convertToDateSlash(result.startDate, DATE_FORMAT),
    endDate: convertToDateSlash(result.endDate, DATE_FORMAT),
    providerId: result.providerId || null,
    subProviderId: result.subProviderId || null,
    includeImeis: result.includeImeis || [],
    purchaseOrders: (result.purchaseOrders || []).map((po) => ({
      id: po.id,
      label: po.code || po.label || String(po.id),
      code: po.code || po.label || String(po.id),
    })),
  };
};
